import React, { useState, useEffect, useMemo } from "react";
import './Controlling.scss';
import EmployeeRow from "../../molecules/EmployeeRow/EmployeeRow";
import Api from "../../../services/ApiService";
import { requestMonthFormat } from '../../../helpers/dateFormat';
import PageLoderSpinner from '../../atoms/PageLoaderSpinner/PageLoderSpinner';
import { formatTime } from "../../../helpers/timeFormat";
import getPreviousMonth from "../../../helpers/getPreviousMonth";

const Controlling = () => {
  const months = useMemo(() => ['April', 'May', 'June', 'July', 'August', 'September', 'October'], []);
  const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear().toString().slice(-2);
  const isExistedMonth = currentMonth <= 9 && currentMonth >= 3;
  const defaultMonth = isExistedMonth ? months[currentMonth - 3] : 'April';
  const [selectedMonth, setSelectedMonth] = useState(defaultMonth);
  const [selectedEmployee, setSelectedEmployee] = useState({});
  const [employeesData, setEmployeesData] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const rows = employeesData?.map((employeeData, i) => (
    <EmployeeRow
      key={employeeData.id}
      employee={employeeData}
      order={i + 1}
      isExpanded={(selectedEmployee.id === employeeData.id && isExpanded)}
      onClick={() => {
        setSelectedEmployee(employeeData);
        setIsExpanded(selectedEmployee.id === employeeData.id ? !isExpanded : true);
      }}
    />
  ));

  let aggregatedExpectedMins = 0;
  let aggregatedRecordedMins = 0;
  
  employeesData.forEach(employeeData => {
    aggregatedExpectedMins = aggregatedExpectedMins + employeeData.minutes_expected;
    aggregatedRecordedMins = aggregatedRecordedMins + employeeData.workdays_sum_minutes_logged;
  });

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const { status, data } = await Api.get(`users/minutes-logged-report?date=${requestMonthFormat(months, selectedMonth)}`);
        if (status === 200) {
          setIsLoading(false);
          setEmployeesData(data.data);
        } else {
          console.log('error');
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
    setIsExpanded(false);
  }, [months, selectedMonth]);

  return (
    <div className="controlling-container">
      <div className="page-title">Controlling</div>
      <div className="month-picker">
        {
          months.map(month => (
            <span
              className={`month-tab ${selectedMonth === month ? 'active' : ''}`}
              onClick={() => setSelectedMonth(month)}
            >
              {month} {new Date().getFullYear()}
            </span>
          ))
        }
      </div>
      {
        isLoading
          ? <div className="spinner-wrapper"><PageLoderSpinner /></div>
          : (
            <>
              <div className="employees-table table-responsive">
                <table className="table table-striped mb-0">
                  <colgroup>
                    <col width="25%" />
                    <col width="25%" />
                    <col width="25%" />
                    <col width="25%" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th className="text-left">Employee</th>
                      <th>Expected hours</th>
                      <th>Recorded hours</th>
                      <th>± Overtime <br />(Aggregated until {getPreviousMonth(selectedMonth)} ‘{currentYear})</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.length
                      ? (
                        <>
                          {rows}
                          <tr className="aggregated-values">
                            <td />
                            <td>{formatTime(aggregatedExpectedMins)}</td>
                            <td>{formatTime(aggregatedRecordedMins)}</td>
                            {/* <td>{formatTime(aggregatedOvertimeMins)}</td> */}
                            <td>-</td>
                          </tr>
                        </>
                      )
                      : (
                        <tr>
                          <td colSpan={4} className="text-center">
                            --- Employees list is empty ---
                          </td>
                        </tr>
                      )}
                  </tbody>
                </table>
              </div>
            </>
          )
      }
    </div>
  );
}

export default Controlling;
